// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__vRH5R","modal":"Modal_modal__V3pA6","slide-down":"Modal_slide-down__kikQA"};